import { render, staticRenderFns } from "./ZoomStarterPage.vue?vue&type=template&id=00b2a839&scoped=true"
import script from "./ZoomStarterPage.vue?vue&type=script&lang=js"
export * from "./ZoomStarterPage.vue?vue&type=script&lang=js"
import style0 from "./ZoomStarterPage.vue?vue&type=style&index=0&id=00b2a839&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b2a839",
  null
  
)

export default component.exports